import VoidWarrantyDialogContainer from "./voidWarrantyDialog.container";

export default VoidWarrantyDialogContainer;
